import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';
import {
  push,
  replace
} from 'react-router-redux';
import {
  Button,
  Container,
  Dimmer,
  Grid,
  Header,
  Icon,
  Label,
  List,
  Loader,
  Menu,
  Modal,
  Segment
} from 'semantic-ui-react';
import {
  Link
} from 'react-router-dom';
import {
  Route
} from 'react-router-dom';
import feathersConnect from './../../../providers/feathersConnect';
import CoopCargosView from './CoopCargosView';
import CoopAsociadosView from './CoopAsociadosView';
import CoopAsambleasView from './CoopAsambleasView';
import CoopEconomicoView from './CoopEconomicoView';
import CoopPrestamosView from './CoopPrestamosView';
import CoopLibrosView from './CoopLibrosView';

const styles = {
  padding: 16
};

class CooperativaDetalleView extends Component {

  constructor (props) {
    super(props);

    this.state = {
      cooperativa: null,
      loading: false
    };

    this.CooperativaService = this.props.feathers.service('/api/cooperativas');
  }

  componentDidMount () {
    this.fetchCooperativa();
  }

  fetchCooperativa () {
    this.setState({
      loading: true
    });

    this.CooperativaService.get(this.props.match.params.id)
      .then(cooperativa => {
        this.setState({
          loading: false,
          cooperativa
        });
      })
      .catch(error => {
        this.setState({
          loading: false
        });
      });
  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    let {
      cooperativa,
      loading
    } = this.state;

    if (loading) {
      return (
        <Container style={styles}>
          <Loader active inline="centered" />
        </Container>
      );
    } else if (cooperativa) {
      return (
        <Container fluid style={styles}>
          <Header as="h2">
            <Icon name="file text outline" />
            <Header.Content>
              {cooperativa.nombre}
              <Header.Subheader>
                {`Matricula Nacional: ${cooperativa.matriculaNacional} - Matricula Provincial: ${cooperativa.matriculaProvincial}`}
              </Header.Subheader>
            </Header.Content>
          </Header>
          <Menu attached="top" tabular>
            <Menu.Item
              as={Link} to={`/cooperativa/${this.props.match.params.id}`}
              active={!!window.location.pathname.match(new RegExp(`^/cooperativa/[0-9]*/?$`))}
              name="General" />
            <Menu.Item
              as={Link} to={`/cooperativa/${this.props.match.params.id}/cargos`}
              active={!!window.location.pathname.match(new RegExp(`^/cooperativa/[0-9]*/cargos/?$|^/cooperativa/[0-9]*/cargos/[0-9]*/?$`))}
              name="Cargos" />
            <Menu.Item
              as={Link} to={`/cooperativa/${this.props.match.params.id}/asociados`}
              active={!!window.location.pathname.match(new RegExp(`^/cooperativa/[0-9]*/asociados/?$`))}
              name="Asociados" />
            <Menu.Item
              as={Link} to={`/cooperativa/${this.props.match.params.id}/asambleas`}
              active={!!window.location.pathname.match(new RegExp(`^/cooperativa/[0-9]*/asambleas/?$`))}
              name="Asambleas" />
            <Menu.Item
              as={Link} to={`/cooperativa/${this.props.match.params.id}/eeconomicos`}
              active={!!window.location.pathname.match(new RegExp(`^/cooperativa/[0-9]*/eeconomicos/?$|^/cooperativa/[0-9]*/eeconomicos/[0-9]*/?$`))}
              name="Economico" />
            <Menu.Item
              as={Link} to={`/cooperativa/${this.props.match.params.id}/prestamos`}
              active={!!window.location.pathname.match(new RegExp(`^/cooperativa/[0-9]*/prestamos/?$|^/cooperativa/[0-9]*/prestamos/[0-9]*/?$`))}
              name="Prestamos" />
            <Menu.Item
              as={Link} to={`/cooperativa/${this.props.match.params.id}/libros`}
              active={!!window.location.pathname.match(new RegExp(`^/cooperativa/[0-9]*/libros/?$|^/cooperativa/[0-9]*/libros/[0-9]*/?$`))}
              name="Libros" />
          </Menu>
          <Route exact path={`/cooperativa/:id`} render={() => {
            return (
              <CoopGeneralView data={cooperativa} />
            );
          }} />
          <Route path={`/cooperativa/:id/cargos`} render={() => {
            return (
              <Segment attached="bottom">
                <CoopCargosView cooperativa={cooperativa} feathers={this.props.feathers} />
              </Segment>
            );
          }} />
          <Route exact path={`/cooperativa/:id/asociados`} render={() => {
            return (
              <Segment attached="bottom">
                <CoopAsociadosView cooperativa={cooperativa} />
              </Segment>
            );
          }} />
          <Route exact path={`/cooperativa/:id/asambleas`} render={() => {
            return (
              <Segment attached="bottom">
                <CoopAsambleasView cooperativa={cooperativa} />
              </Segment>
            );
          }} />
          <Route path={`/cooperativa/:id/eeconomicos`} render={() => {
            return (
              <Segment attached="bottom">
                <CoopEconomicoView cooperativa={cooperativa} feathers={this.props.feathers} />
              </Segment>
            );
          }} />
          <Route path={`/cooperativa/:id/prestamos`} render={() => {
            return (
              <Segment attached="bottom">
                <CoopPrestamosView cooperativa={cooperativa} feathers={this.props.feathers} />
              </Segment>
            );
          }} />
          <Route path={`/cooperativa/:id/libros`} render={() => {
            return (
              <Segment attached="bottom">
                <CoopLibrosView cooperativa={cooperativa} feathers={this.props.feathers} />
              </Segment>
            );
          }} />
        </Container>
      );
    } else {
      return (
        <Container style={styles}>
          !!!
        </Container>
      );
    }
  }
}

export default feathersConnect(
  connect(
    CooperativaDetalleView.mapStateToProps,
    CooperativaDetalleView.mapDispatchToProps
  )(CooperativaDetalleView)
);

const CoopGeneralView = ({ data }) => {
  const headerStyle = { marginTop: 4 };

  return (
    <Segment attached="bottom">
      <Grid padded columns="equal">
        <Grid.Column>
          <Segment raised>
            <Label color="red" ribbon>CUIT</Label>
            <Header style={headerStyle} as="h5">
              <Header.Content>
                {data.cuit}
              </Header.Content>
            </Header>
            <Label color="blue" ribbon>Domicilio Postal</Label>
            <Header style={headerStyle} as="h5">
              <Header.Content>
                {data.domicilioPostal}
                <Header.Subheader>
                  {data.codigoPostal}
                </Header.Subheader>
              </Header.Content>
            </Header>
            <Label color="blue" ribbon>Actividad</Label>
            <Header style={headerStyle} as="h5">
              <Header.Content>
                {data.actividad}
              </Header.Content>
            </Header>
            <Label color="blue" ribbon>Observacion</Label>
            <Header style={headerStyle} as="h5">
              <Header.Content>
                {data.observacion}
              </Header.Content>
            </Header>
          </Segment>
        </Grid.Column>
        <Grid.Column>
          <Segment>
            <Label color="blue" ribbon="right">Situacion</Label>
            <Header style={headerStyle} textAlign="right" as="h5">
              <Header.Content>
                {data.situacion}
              </Header.Content>
            </Header>
            <Label color="orange" ribbon="right">Nro Carpeta y Protocolo</Label>
            <Header style={headerStyle} textAlign="right" as="h5">
              <Header.Content>
                {data.nroCarpeta}
                <Header.Subheader>
                  {data.protocolo}
                </Header.Subheader>
              </Header.Content>
            </Header>
            <Label color="teal" ribbon="right">Fundacion y Cierre</Label>
            <Header style={headerStyle} textAlign="right" as="h5">
              <Header.Content>
                {data.fechaFundacion}
                <Header.Subheader>
                  {data.cierreEjercicio}
                </Header.Subheader>
              </Header.Content>
            </Header>
            <Label color="blue" ribbon="right">Email y Telefono</Label>
            <Header style={headerStyle} textAlign="right" as="h5">
              <Header.Content>
                {data.email}
                <Header.Subheader>
                  {data.telefono}
                </Header.Subheader>
              </Header.Content>
            </Header>
            <Label color="blue" ribbon="right">Contacto</Label>
            <Header style={headerStyle} textAlign="right" as="h5">
              <Header.Content>
                {data.contacto}
              </Header.Content>
            </Header>
          </Segment>
        </Grid.Column>
      </Grid>
    </Segment>
  );
};


// WEBPACK FOOTER //
// ./client/components/pages/cooperativas/CooperativaDetalleView.js